import { render } from "./TopContentCard.vue?vue&type=template&id=4acd64c6"
import script from "./TopContentCard.vue?vue&type=script&lang=js"
export * from "./TopContentCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__